<div class="modal-header">
    <h2 class="modal-title">Select Pickup Lines to Complete</h2>
</div>
<div class="modal-body" style="min-height: 800px">
    <p>The line amount is less than the pickUp line quantity. Please remove any vendor pickUp lines you do not want to complete.</p>
    <table class="table m-t-sm">
        <thead>
            <tr>
                <th></th>
                <th>PickUp Qty</th>
                <th>Order Qty</th>
                <th>Total Received</th>
                <th>PickUp Id</th>
                <th>PickUp Date</th>
                <th>PO #</th>
                <th>Part #</th>
                <th>Mfg Part #</th>
                <th>Description</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let line of pickupLines" [ngClass]="line.completed ? 'completed-pickup ' : ''">
                <td>
                    <a title="remove" (click)="remove(line)"><i class="fa fa-times pt-3" style="color: maroon"></i></a>
                </td>
                <td>{{ line.quantity }}</td>
                <td>{{ line.purchaseOrderLine?.quantity }}</td>
                <td>{{ line.purchaseOrderLine?.quantityReceived }}</td>
                <td>{{ line.purchaseOrderPickUpId }}</td>
                <td>{{ line.purchaseOrderPickUp?.scheduledDate | date : 'MM/dd/yy' }}</td>
                <td>{{ line.purchaseOrderLine?.purchaseOrder?.pONumber }}</td>
                <td>{{ line.purchaseOrderLine?.partNumber }}</td>
                <td>{{ line.purchaseOrderLine?.mfgPartNumber }}</td>
                <td>{{ line.purchaseOrderLine?.description }}</td>
            </tr>
        </tbody>
    </table>
</div>

<div class="modal-footer">
    <button class="btn btn-success" (click)="save()">Save</button>
</div>
